import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=6c6369bd&scoped=true&"
import script from "./MessageComposer.vue?vue&type=script&lang=js&"
export * from "./MessageComposer.vue?vue&type=script&lang=js&"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&id=6c6369bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6369bd",
  null
  
)

export default component.exports